import { Link, styled } from '@mui/material';

export const FinancingOfferLink = styled(Link)(({ theme }) => ({
  '&:hover,&:active,&:focus': {
    fontWeight: theme.typography.fontWeightBold
  }
}));
